import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Checkbox.scss";

export const Checkbox = ({
    className,
    value,
    label,
    disabled = false,
    onChange = () => {}
}) => {
    const handleChange = useCallback(() => {
        onChange(!value);
    }, [ value, onChange ]);

    return (
        <div
            className={classNames(
                "checkbox",
                { "checkbox--checked": value },
                { "checkbox--disabled": disabled },
                className
            )}
            role="checkbox"
            aria-checked={value}
        >
            <div className="checkbox__container">
                <svg
                    className="checkbox__checkmark-container"
                    viewBox="0 0 20 20"
                    onClick={handleChange}
                >
                    <path
                        className="checkbox__checkmark-bottom-pad"
                        d="M 0 2 A 2 2 0 0 1 2 0 L 18 0 A 2 2 0 0 1 20 2 L 20 18 A 2 2 0 0 1 18 20 L 2 20 A 2 2 0 0 1 0 18 Z"
                    />
                    <path
                        className="checkbox__checkmark-top-pad"
                        d="M 0 2 A 2 2 0 0 1 2 0 L 18 0 A 2 2 0 0 1 20 2 L 20 18 A 2 2 0 0 1 18 20 L 2 20 A 2 2 0 0 1 0 18 Z"
                    />
                    <polyline
                        className="checkbox__checkmark"
                        points="4 11 8 15 16 6"
                    />
                </svg>
                { label && (
                    <div
                        className="checkbox__label"
                        aria-label={`Toggle ${label}`}
                        role="button"
                        tabIndex={0}
                        onClick={handleChange}
                    >
                        { label }
                    </div>
                ) }
            </div>
        </div>
    );
};

Checkbox.propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
    disabled: PropTypes.bool
};
